import ShiftsConfigTable from "./ShiftsConfigTable";
import Card from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import useSelectedNode from "../../components/hooks/nodeContext";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import AmpApi from "../../common/api/AmpApi";
import {IShiftsConfig} from "../../common/api/api";
import Loader from "@amzn/meridian/loader";
import Box from "@amzn/meridian/box";
import { Redirect } from "react-router";

function ShiftsConfig() {
    const {selectedNode, changeSelectedNode} = useSelectedNode();
    const [isLoading, setIsLoading] = useState(false);
    const [shiftsConfigList, setShiftsConfigList] = useState([]);
    //Get nodeId from the url
    const {nodeId} = useParams<{ nodeId: string }>();
    let nodeKey;
    if (nodeId) {
        nodeKey = nodeId;
    } else {
        nodeKey = {selectedNode};
    }
    //Load shifts_config entries when the page first loads
    useEffect(() => {
        setIsLoading(true);
        if (nodeId !== selectedNode) {
            changeSelectedNode(nodeId);
        }
        (async () => {
            try {
                const getResponse = await AmpApi.getShiftsConfig(nodeKey);
                if (getResponse) {
                    const shiftsConfigs: IShiftsConfig[] = getResponse.data
                        .shiftInfos as IShiftsConfig[];
                    const finalList = [...shiftsConfigs];
                    setShiftsConfigList(finalList);
                }
            } catch (ex: any) {
                console.error(`Error fetching ${selectedNode}`, ex);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    return (
        nodeId != selectedNode ? (
            <Redirect to="/"/>
        ) : (
            <>
                <Card width="fill" spacingInset="none">
                    <Column spacingInset="400 500" alignmentHorizontal={"center"}>
                        {isLoading ? (
                            <Loader/>
                        ) : (
                            <Box type="outline" spacingInset="400">
                                <ShiftsConfigTable
                                    selectedNode={selectedNode}
                                    shiftsConfigList={shiftsConfigList}
                                />
                            </Box>
                        )}
                    </Column>
                </Card>
            </>
        )
    );
}

export default ShiftsConfig;
